import { FaCheckCircle } from "react-icons/fa";
import { HiArrowTopRightOnSquare } from "react-icons/hi2";
import {
  ResultStatusIcon,
  SummaryRow,
  TransactionDetailsCard,
} from "../../../shared/result/ResultPrimitives";
import {
  formatDateTimeToLocale,
  formatKES,
} from "../../../../utils/transactionutils";
import CustomButton from "../../../ui/CustomButton/CustomButton";

export function SuccessView({
  amount,
  transactionId,
  createdDate,
  transactionFee,
  totalDeducted,
  newBalance,
  onNewWithdrawal,
  onViewTransactions,
}) {
  return (
    <div className="flex flex-col items-center gap-6">
      <ResultStatusIcon
        icon={FaCheckCircle}
        bgClassName="bg-primary-50"
        iconClassName="text-primary-600"
      />

      <div className="text-center space-y-1">
        <p className="text-sm sm:text-base font-semibold text-green-600">
          Withdrawal Successful!
        </p>
        <p className="text-3xl sm:text-4xl font-bold text-gray-900">
          {formatKES(amount)}
        </p>
      </div>

      <TransactionDetailsCard>
        {transactionId && (
          <SummaryRow label="Transaction ID" value={transactionId} stacked />
        )}
        {createdDate && (
          <SummaryRow
            label="Date"
            value={formatDateTimeToLocale(createdDate)}
          />
        )}
        <SummaryRow label="Amount" value={formatKES(amount)} />
        <SummaryRow label="Transaction Fee" value={formatKES(transactionFee)} />
        <SummaryRow
          label="Total Deducted"
          value={formatKES(totalDeducted)}
          bold
        />
        <SummaryRow label="New Balance" value={formatKES(newBalance)} />
      </TransactionDetailsCard>

      <div className="w-full max-w-sm mx-auto space-y-2">
        <CustomButton
          fullWidth
          color="primary"
          radius="md"
          onClick={onNewWithdrawal}
        >
          Make Another Withdrawal
        </CustomButton>
        <CustomButton
          fullWidth
          variant="outline"
          color="gray"
          radius="md"
          leftSection={<HiArrowTopRightOnSquare style={{ fontSize: 14 }} />}
          onClick={onViewTransactions}
        >
          View in Transactions
        </CustomButton>
      </div>
    </div>
  );
}
